import { useReportDateState } from "../hooks/useReportDateAccess";
// // src/pages/SalesReportPage.jsx
// import React, { useState, useEffect, useRef, useMemo } from "react";
// import styled, { keyframes } from "styled-components";
// import {
//   FaCalendarAlt,
//   FaDownload,
//   FaChartBar,
//   FaClipboardList,
//   FaRupeeSign,
//   FaSyncAlt,
//   FaStar,
//   FaListOl,
// } from "react-icons/fa";
// import html2pdf from "html2pdf.js";

// /* ====== Brand Palette ====== */
// const COLOR = {
//   primary: "var(--app-primary)",
//   primary2: "var(--app-primary-hover)",
//   bg: "#f5f7fb",
//   card: "#ffffff",
//   line: "#e8eef5",
//   text: "#1f2937",
//   muted: "#6b7280",
//   successBg: "#e8f5e9",
//   tableHead: "#e9f4fb",
// };

// const SalesReportPage = () => {
//   const [fromDate, setFromDate] = useState(() =>
//     new Date().toISOString().slice(0, 10)
//   );
//   const [toDate, setToDate] = useState(() =>
//     new Date().toISOString().slice(0, 10)
//   );
//   const [loading, setLoading] = useState(false);
//   const [refreshing, setRefreshing] = useState(false);
//   const [error, setError] = useState("");
//   const [data, setData] = useState({
//     total_sale_count: 0,
//     total_sales_quantity: 0,
//     total_sale_amount: 0,
//     list: [],
//   });
//   const [page, setPage] = useState(0);
//   const rowsPerPage = 10;
//   const [expanded, setExpanded] = useState(new Set());
//   const reportRef = useRef();

//   const pageCount = Math.ceil((data?.list?.length || 0) / rowsPerPage);
//   const start = page * rowsPerPage;
//   const presets = useMemo(() => {
//     const today = new Date();
//     const toISO = (d) => d.toISOString().slice(0, 10);
//     const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
//     const startOfWeek = () => {
//       const t = new Date();
//       const day = t.getDay();
//       const diff = t.getDate() - day + (day === 0 ? -6 : 1); // Monday
//       t.setDate(diff);
//       return t;
//     };
//     const startOfMonth = () => new Date(today.getFullYear(), today.getMonth(), 1);
//     return [
//       { label: "Today", from: toISO(today), to: toISO(today) },
//       { label: "Yesterday", from: toISO(yesterday), to: toISO(yesterday) },
//       { label: "This Week", from: toISO(startOfWeek()), to: toISO(today) },
//       { label: "This Month", from: toISO(startOfMonth()), to: toISO(today) },
//     ];
//   }, []);

//   useEffect(() => {
//     fetchReport();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [fromDate, toDate]);

//   async function fetchReport(opts = {}) {
//     const user = JSON.parse(localStorage.getItem("userData"))?.data;
//     if (!user?.id) return;
//     setError("");
//     if (opts.refresh) setRefreshing(true);
//     else setLoading(true);
//     try {
//       const resp = await fetch(
//         "https://qr.billsarthi.in/public/api/getsalereport",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             restaurantid: user.id,
//             fromdate: fromDate,
//             todate: toDate,
//           }),
//         }
//       );
//       const json = await resp.json();
//       if (resp.ok) {
//         setData(
//           json || {
//             total_sale_count: 0,
//             total_sales_quantity: 0,
//             total_sale_amount: 0,
//             list: [],
//           }
//         );
//         setPage(0);
//         setExpanded(new Set());
//       } else {
//         setError(json.message || "Failed to load report");
//       }
//     } catch (e) {
//       setError(e.message || "Network error");
//     } finally {
//       if (opts.refresh) setRefreshing(false);
//       else setLoading(false);
//     }
//   }

//   const toggle = (sno) => {
//     setExpanded((prev) => {
//       const s = new Set(prev);
//       s.has(sno) ? s.delete(sno) : s.add(sno);
//       return s;
//     });
//   };

//   const exportPDF = () => {
//     if (!reportRef.current || (data?.list?.length || 0) === 0) return;
//     html2pdf()
//       .set({
//         margin: 8,
//         filename: `sales_report_${fromDate}_to_${toDate}.pdf`,
//         html2canvas: { scale: 2 },
//       })
//       .from(reportRef.current)
//       .save();
//   };

//   const fmtINR = useMemo(
//     () =>
//       new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }),
//     []
//   );
//   const fmtDate = (d) => {
//     try {
//       return new Date(d).toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
//     } catch {
//       return d;
//     }
//   };
//   const fmtTime = (d) =>
//     new Date(d).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });

//   const topItem = useMemo(() => {
//     const tally = {};
//     (data?.list || []).forEach((row) => {
//       (row.summary || []).forEach((item) => {
//         tally[item.item_name] = (tally[item.item_name] || 0) + Number(item.total_quantity || 0);
//       });
//     });
//     const entries = Object.entries(tally);
//     if (!entries.length) return null;
//     const [name, qty] = entries.sort((a, b) => b[1] - a[1])[0];
//     return { name, qty };
//   }, [data]);

//   return (
//     <Page>
//       <TopBar>
//         <TopLeft>
//           <Title>Sales Report</Title>
//           <Sub>Track daily summaries and item-wise breakdowns</Sub>
//           <PresetRow>
//             {presets.map((p) => (
//               <PresetChip
//                 key={p.label}
//                 $active={p.from === fromDate && p.to === toDate}
//                 onClick={() => {
//                   setFromDate(p.from);
//                   setToDate(p.to);
//                 }}
//               >
//                 {p.label}
//               </PresetChip>
//             ))}
//             <RefreshBtn onClick={() => fetchReport({ refresh: true })}>
//               <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
//             </RefreshBtn>
//           </PresetRow>
//         </TopLeft>
//         <TopRight>
//           <InputWrap>
//             <InputLabel>
//               <FaCalendarAlt /> From
//             </InputLabel>
//             <DateInput
//               type="date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               max={toDate}
//             />
//           </InputWrap>
//           <InputWrap>
//             <InputLabel>
//               <FaCalendarAlt /> To
//             </InputLabel>
//             <DateInput
//               type="date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//               min={fromDate}
//             />
//           </InputWrap>
//           <ExportBtn onClick={exportPDF} disabled={(data?.list || []).length === 0}>
//             <FaDownload /> Export PDF
//           </ExportBtn>
//         </TopRight>
//       </TopBar>

//       <Main ref={reportRef}>
//         <KpiRow>
//           <KpiCard>
//             <KpiIcon style={{ color: COLOR.primary }}>
//               <FaClipboardList />
//             </KpiIcon>
//             <KpiLabel>Total Orders</KpiLabel>
//             <KpiValue>{data.total_sale_count || 0}</KpiValue>
//             <KpiSub>
//               {fromDate} → {toDate}
//             </KpiSub>
//           </KpiCard>
//           <KpiCard>
//             <KpiIcon style={{ color: COLOR.primary2 }}>
//               <FaChartBar />
//             </KpiIcon>
//             <KpiLabel>Total Quantity</KpiLabel>
//             <KpiValue>{data.total_sales_quantity || 0}</KpiValue>
//             <KpiSub>All items combined</KpiSub>
//           </KpiCard>
//           <KpiCard>
//             <KpiIcon style={{ color: "#0f9d58" }}>
//               <FaRupeeSign />
//             </KpiIcon>
//             <KpiLabel>Total Amount</KpiLabel>
//             <KpiValue>
//               {fmtINR.format(Number(data.total_sale_amount || 0))}
//             </KpiValue>
//             <KpiSub>Gross for selected period</KpiSub>
//           </KpiCard>
//         </KpiRow>

//         <BadgeRow>
//           <Pill>Txn: {data.list.length || 0}</Pill>
//           <Pill>Period: {fromDate} → {toDate}</Pill>
//           {topItem ? (
//             <Pill className="accent">
//               <FaStar /> Top item: {topItem.name} ({topItem.qty})
//             </Pill>
//           ) : null}
//         </BadgeRow>

//         {/* Table / Loader */}
//         {loading ? (
//           <Card>
//             <Loader />
//             <LoaderLine />
//             <LoaderLine />
//             <LoaderLine />
//           </Card>
//         ) : (
//           <Card>
//             <Table>
//               <thead>
//                 <tr>
//                   <Th style={{ width: 80 }}>Sr No</Th>
//                   <Th style={{ minWidth: 120 }}>Date</Th>
//                   <Th>Txn No</Th>
//                   <Th style={{ width: 120, textAlign: "right" }}>Qty</Th>
//                   <Th style={{ width: 160, textAlign: "right" }}>Amount</Th>
//                   <Th style={{ width: 120 }}>Time</Th>
//                   <Th style={{ width: 70 }}></Th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.list.slice(start, start + rowsPerPage).map((row) => (
//                   <React.Fragment key={row.sno}>
//                     <tr>
//                       <Td>{row.sno}</Td>
//                       <Td>{fmtDate(row.date)}</Td>
//                       <Td>
//                         <TxnBadge>{row.txn_no}</TxnBadge>
//                       </Td>
//                       <Td style={{ textAlign: "right" }}>
//                         {row.total_quantity}
//                       </Td>
//                       <Td style={{ textAlign: "right", fontWeight: 700 }}>
//                         {fmtINR.format(Number(row.total_amount || 0))}
//                       </Td>
//                       <Td>{fmtTime(row.created_at || row.date)}</Td>
//                       <Td>
//                         <Expand onClick={() => toggle(row.sno)}>
//                           {expanded.has(row.sno) ? "Hide" : "View"}
//                         </Expand>
//                       </Td>
//                     </tr>
//                     {expanded.has(row.sno) && (
//                       <>
//                         <tr className="subHead">
//                           <Td></Td>
//                           <Td
//                             colSpan={2}
//                             style={{ fontWeight: 700, color: COLOR.muted }}
//                           >
//                             Item
//                           </Td>
//                           <Td
//                             style={{
//                               textAlign: "right",
//                               fontWeight: 700,
//                               color: COLOR.muted,
//                             }}
//                           >
//                             Qty
//                           </Td>
//                           <Td
//                             style={{
//                               textAlign: "right",
//                               fontWeight: 700,
//                               color: COLOR.muted,
//                             }}
//                           >
//                             Amount
//                           </Td>
//                           <Td></Td>
//                         </tr>
//                         {row.summary.map((item, i) => (
//                           <tr key={`${row.sno}-${i}`} className="subRow">
//                             <Td>{i + 1}</Td>
//                             <Td colSpan={2}>{item.item_name}</Td>
//                             <Td style={{ textAlign: "right" }}>
//                               {item.total_quantity}
//                             </Td>
//                             <Td style={{ textAlign: "right" }}>
//                               {fmtINR.format(Number(item.total_amount || 0))}
//                             </Td>
//                             <Td></Td>
//                           </tr>
//                         ))}
//                       </>
//                     )}
//                   </React.Fragment>
//                 ))}

//                 {data.list.length === 0 && (
//                   <tr>
//                     <Td
//                       colSpan={6}
//                       style={{
//                         textAlign: "center",
//                         padding: 24,
//                         color: COLOR.muted,
//                       }}
//                     >
//                       No records found for the selected range.
//                     </Td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>

//             {/* Pagination */}
//             <Pager>
//               <PageBtn
//                 disabled={page === 0}
//                 onClick={() => setPage((p) => p - 1)}
//               >
//                 ‹ Prev
//               </PageBtn>
//               <PageInfo>
//                 Page <strong>{pageCount ? page + 1 : 0}</strong> of{" "}
//                 <strong>{pageCount}</strong>
//               </PageInfo>
//               <PageBtn
//                 disabled={page + 1 >= pageCount}
//                 onClick={() => setPage((p) => p + 1)}
//               >
//                 Next ›
//               </PageBtn>
//             </Pager>
//             {error ? <ErrorText>{error}</ErrorText> : null}
//           </Card>
//         )}
//       </Main>
//     </Page>
//   );
// };

// export default SalesReportPage;

// /* ===================== Styles ===================== */

// const Page = styled.div`
//   min-height: 100vh;
//   background: ${COLOR.bg};
//   font-family: Inter, system-ui, Segoe UI, Roboto, "Helvetica Neue", Arial;
//   color: ${COLOR.text};
// `;

// const TopBar = styled.div`
//   position: sticky;
//   top: 0;
//   z-index: 5;
//   background: linear-gradient(90deg, ${COLOR.primary}, ${COLOR.primary2});
//   padding: 16px 20px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   border-bottom: 1px solid var(--app-primary);
// `;

// const TopLeft = styled.div``;
// const Title = styled.h1`
//   color: #fff;
//   margin: 0;
//   font-weight: 800;
//   font-size: 20px;
// `;
// const Sub = styled.div`
//   color: var(--app-primary-soft);
//   font-size: 13px;
//   margin-top: 4px;
// `;
// const PresetRow = styled.div`
//   display: flex;
//   gap: 8px;
//   margin-top: 10px;
//   flex-wrap: wrap;
// `;
// const PresetChip = styled.button`
//   border: 1px solid ${COLOR.line};
//   background: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.12)")};
//   color: ${({ $active }) => ($active ? COLOR.primary : "var(--app-primary-soft)")};
//   border-radius: 999px;
//   padding: 8px 12px;
//   font-weight: 800;
//   cursor: pointer;
//   transition: all 0.15s ease;
//   &:hover {
//     transform: translateY(-1px);
//     box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
//   }
// `;
// const RefreshBtn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 6px;
//   padding: 8px 12px;
//   border-radius: 10px;
//   border: 1px solid #fff;
//   background: rgba(255, 255, 255, 0.14);
//   color: #fff;
//   font-weight: 800;
//   cursor: pointer;
// `;

// const TopRight = styled.div`
//   display: flex;
//   align-items: end;
//   gap: 10px;
//   flex-wrap: wrap;
// `;

// const InputWrap = styled.div`
//   display: grid;
//   gap: 6px;
// `;
// const InputLabel = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   color: var(--app-primary-soft);
//   font-size: 12px;
//   font-weight: 700;
//   svg {
//     opacity: 0.95;
//   }
// `;
// const DateInput = styled.input`
//   background: #ffffff;
//   border: 1px solid ${COLOR.line};
//   color: ${COLOR.text};
//   border-radius: 10px;
//   padding: 10px 12px;
//   min-width: 180px;
//   outline: none;
//   &:focus {
//     border-color: ${COLOR.primary};
//     box-shadow: 0 0 0 3px rgba(var(--app-primary-rgb), 0.12);
//   }
// `;

// const ExportBtn = styled.button`
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: #f57c00;
//   color: #fff;
//   border: none;
//   border-radius: 10px;
//   padding: 10px 14px;
//   font-weight: 800;
//   cursor: pointer;
//   &:hover {
//     background: #ef6c00;
//   }
// `;

// const Main = styled.div`
//   padding: 22px;
// `;

// const KpiRow = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 16px;
//   margin-bottom: 18px;
//   @media (max-width: 900px) {
//     grid-template-columns: 1fr;
//   }
// `;

// const KpiCard = styled.div`
//   background: ${COLOR.card};
//   border: 1px solid ${COLOR.line};
//   border-radius: 16px;
//   padding: 18px;
//   box-shadow: 0 10px 30px rgba(var(--app-primary-rgb), 0.08);
//   display: grid;
//   grid-template-columns: auto 1fr;
//   column-gap: 12px;
//   align-items: center;
// `;
// const KpiIcon = styled.div`
//   width: 40px;
//   height: 40px;
//   display: grid;
//   place-items: center;
//   font-size: 20px;
// `;
// const KpiLabel = styled.div`
//   color: ${COLOR.muted};
//   font-weight: 700;
//   font-size: 13px;
// `;
// const KpiValue = styled.div`
//   font-size: 22px;
//   font-weight: 900;
// `;
// const KpiSub = styled.div`
//   color: ${COLOR.muted};
//   font-size: 12px;
//   margin-top: 4px;
// `;

// const BadgeRow = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   gap: 10px;
//   margin-bottom: 12px;
// `;
// const Pill = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 8px;
//   background: #ecf2ff;
//   color: ${COLOR.text};
//   border: 1px solid ${COLOR.line};
//   border-radius: 999px;
//   padding: 8px 12px;
//   font-weight: 700;
//   &.accent {
//     background: #fff7ed;
//     border-color: #fed7aa;
//   }
// `;

// const Card = styled.div`
//   background: ${COLOR.card};
//   border: 1px solid ${COLOR.line};
//   border-radius: 16px;
//   padding: 16px;
//   box-shadow: 0 10px 30px rgba(var(--app-primary-rgb), 0.08);
// `;

// const Table = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   font-size: 14px;
//   overflow: hidden;
//   border-radius: 12px;
//   thead {
//     background: ${COLOR.tableHead};
//     th {
//       color: ${COLOR.text};
//       font-weight: 800;
//       padding: 12px;
//       text-align: left;
//       border-bottom: 1px solid ${COLOR.line};
//     }
//   }
//   tbody {
//     tr {
//       background: #fff;
//     }
//     tr:nth-child(even) {
//       background: #fbfdff;
//     }
//     tr:hover {
//       background: #f4faff;
//     }
//     .subHead td {
//       background: #f4f7fb;
//       border-top: 1px solid ${COLOR.line};
//       font-size: 13px;
//     }
//     .subRow td {
//       background: ${COLOR.successBg};
//     }
//     td {
//       padding: 12px;
//       border-bottom: 1px solid ${COLOR.line};
//       vertical-align: middle;
//     }
//   }
// `;

// const Th = styled.th``;
// const Td = styled.td``;

// const TxnBadge = styled.span`
//   display: inline-block;
//   background: #ecf5ff;
//   color: ${COLOR.primary};
//   border: 1px solid ${COLOR.primary}22;
//   padding: 6px 10px;
//   border-radius: 999px;
//   font-weight: 800;
// `;

// const Expand = styled.button`
//   background: var(--app-primary-soft);
//   color: ${COLOR.primary};
//   border: 1px solid ${COLOR.primary};
//   border-radius: 10px;
//   padding: 6px 10px;
//   font-weight: 800;
//   cursor: pointer;
// `;

// const Pager = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   gap: 12px;
//   margin-top: 14px;
// `;
// const PageBtn = styled.button`
//   padding: 8px 14px;
//   border-radius: 10px;
//   border: 1px solid ${COLOR.primary};
//   background: var(--app-primary-soft);
//   color: ${COLOR.primary};
//   font-weight: 800;
//   cursor: pointer;
//   &:disabled {
//     opacity: 0.5;
//     cursor: default;
//   }
// `;
// const PageInfo = styled.div`
//   color: ${COLOR.muted};
// `;
// const ErrorText = styled.div`
//   margin-top: 10px;
//   color: #c2410c;
//   text-align: center;
//   font-weight: 700;
// `;

// /* ------- Loader ------- */
// const shimmer = keyframes`
//   0% { background-position: -450px 0; }
//   100% { background-position: 450px 0; }
// `;
// const Loader = styled.div`
//   height: 18px;
//   border-radius: 6px;
//   margin: 4px 0 12px 0;
//   background: linear-gradient(90deg, #eef3f7 25%, #e3edf7 50%, #eef3f7 75%);
//   background-size: 900px 100%;
//   animation: ${shimmer} 1.1s linear infinite;
// `;
// const LoaderLine = styled(Loader)`
//   height: 14px;
// `;
// src/pages/SalesReportPage.jsx
import React, { useState, useEffect, useRef, useMemo } from "react";
import { localToday, toLocalYmd } from "../utils/localDate";
import styled, { keyframes } from "styled-components";
import {
  FaCalendarAlt,
  FaDownload,
  FaFileExcel,
  FaChartBar,
  FaClipboardList,
  FaSyncAlt,
  FaStar,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { downloadExcel, downloadPDF, printThermal, printThermalViaUsb} from "../utils/exportHelpers";
import { formatMoney, getCurrencySymbol, readStoredCurrencyContext } from "../utils/currency";
import ReportPeriodPicker from "../components/ReportPeriodPicker";
import ReportPageHeader from "../components/ReportPageHeader";
import ReportControlBar from "../components/ReportControlBar";
import { API_ENDPOINTS } from "../config/constants";
import { formatSaleWeight } from "../utils/weightedSales";
import { buildCategorySalesReceiptText } from "../utils/categorySalesReport";
import { resolveOfflineOrderCode } from "../offline/orderCode";

/* ====== Brand Palette ====== */
const COLOR = {
  primary: "var(--app-primary)",
  primary2: "var(--app-primary-hover)",
  bg: "#f5f7fb",
  card: "#ffffff",
  line: "#e8eef5",
  text: "#1f2937",
  muted: "#6b7280",
  successBg: "#e8f5e9",
  tableHead: "#e9f4fb",
};

const DEFAULT_TAKEAWAY_NAME = "TakeAway-1";
const DESKTOP_CACHE_HEADER = "x-billsarthi-desktop-cache";

const isDesktopApp = () =>
  typeof window !== "undefined" &&
  window.desktopRuntime?.isElectron === true &&
  Boolean(window.desktopOrders);

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const isWeightedItem = (item) =>
  item?.is_weight_line === true ||
  item?.is_weight_line === 1 ||
  item?.is_weight_line === "1";

const resolveItemWeightLabel = (item) => {
  const explicitLabel = String(
    item?.weight_label ?? item?.weightLabel ?? ""
  ).trim();
  if (explicitLabel) return explicitLabel;

  const grams = toNumber(
    item?.sold_weight_grams ?? item?.soldWeightGrams ?? 0
  );
  if (grams > 0) return formatSaleWeight(grams);

  const quantity = toNumber(
    item?.total_quantity ?? item?.qty ?? item?.quantity ?? 0
  );
  return isWeightedItem(item) && quantity > 0
    ? formatSaleWeight(quantity * 1000)
    : "";
};

const stripWeightSuffix = (name, weightLabel) => {
  const value = String(name || "Item").trim();
  const suffix = weightLabel ? ` · ${weightLabel}` : "";
  return suffix && value.endsWith(suffix)
    ? value.slice(0, -suffix.length).trim()
    : value;
};

const indiaDateKey = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  // The API commonly returns a UTC timestamp without its Z suffix.
  const normalized = /^\d{4}-\d{2}-\d{2}\s/.test(raw)
    ? `${raw.replace(" ", "T")}Z`
    : raw;
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return raw.slice(0, 10);
  const parts = new Intl.DateTimeFormat("en", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  })
    .formatToParts(date)
    .reduce((result, part) => ({ ...result, [part.type]: part.value }), {});
  return `${parts.year}-${parts.month}-${parts.day}`;
};

const displayDate = (value) => {
  const [year, month, day] = String(value || "").split("-");
  return year && month && day ? `${day}-${month}-${year}` : String(value || "");
};

const orderItems = (order) => {
  const candidates = [
    order?.summary,
    order?.itemslist,
    order?.orderitems,
    order?.itemlist,
    order?.items,
    order?.payload?.itemlist,
  ];
  return candidates.find(Array.isArray) || [];
};

const makeOfflineSalesReport = (orders = [], pending = []) => {
  const dedupe = new Set();
  const rows = [...pending, ...orders]
    .filter((order) => {
      const key = String(order?.id ?? order?.orderid ?? order?.ordercode ?? "");
      if (!key || dedupe.has(key)) return false;
      dedupe.add(key);
      return true;
    })
    .map((order, index) => {
      const items = orderItems(order);
      const summary = items.map((item) => {
        const quantity = toNumber(item?.total_quantity ?? item?.qty ?? item?.quantity);
        const price = toNumber(item?.total_amount ?? item?.amount ?? item?.priceaftertax ?? item?.price);
        const weightLabel = resolveItemWeightLabel(item);
        return {
          item_name: stripWeightSuffix(
            item?.item_name ??
              item?.product_name ??
              item?.productname ??
              item?.name ??
              item?.title ??
              "Item",
            weightLabel
          ),
          total_quantity: quantity,
          total_amount: item?.total_amount !== undefined ? price : price * quantity,
          is_weight_line: isWeightedItem(item) ? 1 : 0,
          sold_weight_grams: item?.sold_weight_grams ?? null,
          weight_label: weightLabel,
        };
      });
      const quantity = toNumber(order?.total_quantity ?? order?.total_items_count) ||
        summary.reduce((total, item) => total + item.total_quantity, 0);
      const amount = toNumber(
        order?.total_amount ?? order?.totalamount ?? order?.totalPrice ??
          order?.grand_total ?? order?.payload?.totalPrice
      );
      const createdAt = order?.created_at ?? order?.createdAt ?? order?.date ?? "";
      return {
        ...order,
        sno: index + 1,
        date: order?.date ?? createdAt,
        created_at: createdAt,
        order_code: order?.order_code ?? order?.ordercode ?? order?.code ??
          (order?.is_pending_sync ? `OFFLINE-${String(order?.id || "").slice(0, 8)}` : "-"),
        total_quantity: quantity,
        total_amount: amount,
        summary,
      };
    })
    .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))
    .map((row, index) => ({ ...row, sno: index + 1 }));

  return {
    total_sale_count: rows.length,
    total_sales_quantity: rows.reduce((total, row) => total + toNumber(row.total_quantity), 0),
    total_sale_amount: rows.reduce((total, row) => total + toNumber(row.total_amount), 0),
    list: rows,
    offline: true,
  };
};

const isTakeawayName = (name) =>
  typeof name === "string" && name.toLowerCase().startsWith("takeaway");

const extractTakeawayIndex = (name) => {
  if (!name) return null;
  const lower = String(name).toLowerCase();
  if (lower === "takeaway") return 1;
  const match = lower.match(/takeaway[\s-]*(\d+)/);
  if (match) {
    const value = parseInt(match[1], 10);
    return Number.isNaN(value) ? null : value;
  }
  return null;
};

const formatTakeawayLabel = (name) => {
  const raw = name === null || name === undefined ? "" : String(name).trim();
  if (!raw || raw === "0" || raw === "-1") return "TakeAway";
  const index = extractTakeawayIndex(raw);
  return index ? `TakeAway ${index}` : raw;
};

const normalizeTableLookup = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const getSalesTableKey = (table) => {
  if (!table) return "";
  const candidate =
    table?.table_key ??
    table?.tableKey ??
    table?.key ??
    table?.name ??
    table?.table ??
    table?.tableid ??
    table?.tableId ??
    table?.id ??
    "";
  return candidate === null || candidate === undefined ? "" : String(candidate);
};

const getSalesTableDisplayName = (table) => {
  if (!table) return "";
  const candidate =
    table?.display_name ??
    table?.displayName ??
    table?.table_key ??
    table?.tableKey ??
    table?.name ??
    table?.table ??
    table?.tableid ??
    table?.tableId ??
    table?.id ??
    "";
  return candidate === null || candidate === undefined ? "" : String(candidate);
};

const getSalesTableType = (table) => {
  const raw =
    table?.table_type ?? table?.tableType ?? table?.tabletype ?? table?.type;
  return String(raw || "").toLowerCase() === "room" ? "room" : "table";
};

const buildSalesTableMetaMap = (list = []) => {
  const map = {};
  if (!Array.isArray(list)) return map;

  list.forEach((entry) => {
    const key = getSalesTableKey(entry);
    const displayName = getSalesTableDisplayName(entry);
    const type = getSalesTableType(entry);
    const meta = {
      displayName: displayName || key || "",
      type,
    };

    const addKey = (candidate) => {
      const normalized = normalizeTableLookup(candidate);
      if (!normalized) return;
      map[normalized] = meta;
    };

    addKey(key);
    addKey(entry?.id);
    addKey(entry?.tableid);
    addKey(entry?.tableId);
    addKey(entry?.table_id);
    addKey(entry?.sort_order);
    addKey(displayName);
    addKey(entry?.name);
  });

  return map;
};

const stripLocationPrefix = (value, type) => {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  if (type === "room") {
    return raw.replace(/^room\s*/i, "").trim();
  }
  if (type === "table") {
    return raw.replace(/^table\s*/i, "").trim();
  }
  return raw;
};

const resolveSalesLocation = (row, tableMetaMap = {}) => {
  const rawId = row?.tableid ?? row?.table_id ?? row?.tableId ?? "";
  const rawDisplay =
    row?.table_display_name ??
    row?.table_name ??
    row?.table_label ??
    row?.table_number_label ??
    "";
  const rawType = String(
    row?.table_type ?? row?.tableType ?? row?.table_type_label ?? ""
  )
    .trim()
    .toLowerCase();

  const meta =
    tableMetaMap[normalizeTableLookup(rawId)] ||
    tableMetaMap[normalizeTableLookup(rawDisplay)] ||
    null;

  const rawIdString = String(rawId ?? "").trim();
  const isTakeaway =
    rawType === "takeaway" ||
    !rawIdString ||
    rawIdString === "0" ||
    rawIdString === "-1" ||
    isTakeawayName(rawIdString) ||
    isTakeawayName(String(rawDisplay || ""));

  if (isTakeaway) {
    return {
      type: "takeaway",
      typeLabel: "TakeAway",
      numberLabel:
        String(row?.table_number_label || "").trim() ||
        formatTakeawayLabel(rawDisplay || rawIdString || DEFAULT_TAKEAWAY_NAME),
    };
  }

  const looksRoom = /room/i.test(String(rawDisplay || ""));
  const type = rawType === "room" || meta?.type === "room" || looksRoom ? "room" : "table";
  const typeLabel = type === "room" ? "Room" : "Table";
  const displayCandidate =
    String(row?.table_number_label || "").trim() ||
    String(rawDisplay || "").trim() ||
    String(meta?.displayName || "").trim() ||
    String(rawIdString || "").trim();
  const cleanedDisplay = stripLocationPrefix(displayCandidate, type);

  return {
    type,
    typeLabel,
    numberLabel: cleanedDisplay || displayCandidate || "-",
  };
};

const SalesReportPage = () => {
  const [fromDate, setFromDate] = useReportDateState(() =>
    localToday()
  );
  const [toDate, setToDate] = useReportDateState(() =>
    localToday()
  );
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState({
    total_sale_count: 0,
    total_sales_quantity: 0,
    total_sale_amount: 0,
    list: [],
  });
  const [tableMetaMap, setTableMetaMap] = useState({});
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const reportRef = useRef();

  // ---- Restaurant info (for PDF header) ----
  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("userData"))?.data || null;
    } catch (e) {
      return null;
    }
  }, []);

  const restaurantName =
    user?.restaurant_name || user?.restaurantname || user?.name || "Restaurant Name";
  const restaurantPhone =
    user?.mobile || user?.phone || user?.contactnumber || null;
  const restaurantAddress =
    user?.addressline1 || user?.address || user?.restaurantaddress || user?.city || null;

  useEffect(() => {
    if (!user?.id) return undefined;
    let active = true;

    try {
      const cached = JSON.parse(localStorage.getItem("tablelistx") || "[]");
      if (active) setTableMetaMap(buildSalesTableMetaMap(cached));
    } catch {
      // ignore cache parse errors
    }

    const hydrateTables = async () => {
      try {
        const response = await fetch(API_ENDPOINTS.LIST_TABLE, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ restaurantid: user.id }),
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result?.list)) return;
        if (!active) return;
        localStorage.setItem("tablelistx", JSON.stringify(result.list));
        setTableMetaMap(buildSalesTableMetaMap(result.list));
      } catch {
        // ignore table list hydrate failures
      }
    };

    hydrateTables();
    return () => {
      active = false;
    };
  }, [user?.id]);

  const pageCount = Math.ceil((data?.list?.length || 0) / rowsPerPage);
  const start = page * rowsPerPage;
  const presets = useMemo(() => {
    const today = new Date();
    const toISO = (d) => toLocalYmd(d);
    const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000);
    const startOfWeek = () => {
      const t = new Date();
      const day = t.getDay();
      const diff = t.getDate() - day + (day === 0 ? -6 : 1); // Monday
      t.setDate(diff);
      return t;
    };
    const startOfMonth = () =>
      new Date(today.getFullYear(), today.getMonth(), 1);
    return [
      { label: "Today", from: toISO(today), to: toISO(today) },
      { label: "Yesterday", from: toISO(yesterday), to: toISO(yesterday) },
      { label: "This Week", from: toISO(startOfWeek()), to: toISO(today) },
      { label: "This Month", from: toISO(startOfMonth()), to: toISO(today) },
    ];
  }, []);

  useEffect(() => {
    fetchReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate]);

  async function fetchReport(opts = {}) {
    const user = JSON.parse(localStorage.getItem("userData"))?.data;
    if (!user?.id) return;
    setError("");
    if (opts.refresh) setRefreshing(true);
    else setLoading(true);
    const loadDesktopOfflineReport = async () => {
      if (!isDesktopApp()) {
        console.info("[Sales Report offline debug] SQLite bridge unavailable", {
          isElectron: window.desktopRuntime?.isElectron === true,
          hasOrdersBridge: Boolean(window.desktopOrders),
        });
        return null;
      }
      const [cachedOrders, queue] = await Promise.all([
        // Read all cached rows then apply the same India calendar as the date picker.
        // This avoids an OS-timezone boundary from excluding a midnight order.
        window.desktopOrders.list({ restaurantId: user.id }),
        window.desktopOrderQueue?.list({ restaurantId: user.id, includeDeferred: true }) || [],
      ]);
      const matchesRange = (value) => {
        const date = indiaDateKey(value);
        return Boolean(date && date >= fromDate && date <= toDate);
      };
      const pending = (queue || [])
        .filter((item) => matchesRange(item?.createdAt))
        .map((item) => ({
          ...item,
          created_at: item.createdAt,
          ordercode: resolveOfflineOrderCode(item),
          totalamount: item?.payload?.totalPrice || 0,
          tableid: item?.payload?.tableid || 0,
          payment_mode: item?.payload?.payment_mode || item?.payload?.mode || "Cash",
          itemlist: item?.payload?.itemlist || [],
          is_pending_sync: item?.metadata?.localOnly !== true,
          is_local_only: item?.metadata?.localOnly === true,
        }));
      const matchingOrders = (cachedOrders || []).filter((order) =>
        matchesRange(order?.created_at ?? order?.createdAt ?? order?.date)
      );
      const report = makeOfflineSalesReport(matchingOrders, pending);
      console.info("[Sales Report offline debug] SQLite fallback", {
        restaurantId: String(user.id),
        fromDate,
        toDate,
        cachedOrderCount: (cachedOrders || []).length,
        dateMatchCount: matchingOrders.length,
        pendingCount: pending.length,
        finalCount: report.list.length,
      });
      return report;
    };

    const applyReport = (report) => {
      setData(report || {
        total_sale_count: 0,
        total_sales_quantity: 0,
        total_sale_amount: 0,
        list: [],
      });
      setPage(0);
    };

    try {
      const resp = await fetch(
        API_ENDPOINTS.REPORT_SALES,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            restaurantid: user.id,
            fromdate: fromDate,
            todate: toDate,
          }),
        }
      );
      const json = await resp.json();
      if (resp.ok) {
        applyReport(json);
        if (resp.headers.get(DESKTOP_CACHE_HEADER)) {
          setError("");
        }
      } else {
        const offlineReport = await loadDesktopOfflineReport();
        if (offlineReport) {
          applyReport(offlineReport);
          setError("");
        } else {
          setError(json.message || "Failed to load report");
        }
      }
    } catch (e) {
      console.warn("[Sales Report offline debug] live report fetch failed", {
        message: e?.message,
        isElectron: window.desktopRuntime?.isElectron === true,
        hasOrdersBridge: Boolean(window.desktopOrders),
      });
      try {
        const offlineReport = await loadDesktopOfflineReport();
        if (offlineReport) {
          applyReport(offlineReport);
          setError("");
        } else {
          setError(e.message || "Network error");
        }
      } catch (offlineError) {
        console.warn("Unable to load desktop offline sales report", offlineError);
        setError(e.message || "Network error");
      }
    } finally {
      if (opts.refresh) setRefreshing(false);
      else setLoading(false);
    }
  }

  const exportExcel = () => {
    if ((data?.list?.length || 0) === 0) return;
    const headers = [
      "#",
      "Date/Time",
      "Bill No",
      "Table / Mode",
      "Customer",
      "Phone",
      "Items Count",
      "Payment Mode",
      "Bill Amount",
    ];
    const rows = (data?.list || []).map((row, idx) => [
      row.sno || idx + 1,
      row.created_at ? `${fmtDate(row.created_at)} ${fmtTime(row.created_at)}` : "-",
      row.billno || "-",
      row.table_name || row.ordertype || "-",
      row.customer_name || "Walk-in",
      row.customer_phone || "-",
      Array.isArray(row.summary) ? row.summary.length : row.total_items_count || 0,
      row.payment_mode || "Cash",
      row.bill_amount || row.totalamount || 0,
    ]);
    downloadExcel(`sales_report_${fromDate}_to_${toDate}.xlsx`, headers, rows);
  };

  const exportPDF = () => {
    if (!reportRef.current || (data?.list?.length || 0) === 0) return;
    downloadPDF(reportRef.current, `sales_report_${fromDate}_to_${toDate}.pdf`);
  };

  const fmtINR = useMemo(() => {
    const context = readStoredCurrencyContext();
    return { format: (value) => formatMoney(value, context) };
  }, []);
  const currencySymbol = useMemo(
    () => getCurrencySymbol(readStoredCurrencyContext()),
    []
  );
  const fmtDate = (d) => {
    try {
      return new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return d;
    }
  };
  const fmtTime = (d) =>
    new Date(d).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });

  const topItem = useMemo(() => {
    const tally = {};
    (data?.list || []).forEach((row) => {
      (row.summary || []).forEach((item) => {
        tally[item.item_name] =
          (tally[item.item_name] || 0) + Number(item.total_quantity || 0);
      });
    });
    const entries = Object.entries(tally);
    if (!entries.length) return null;
    const [name, qty] = entries.sort((a, b) => b[1] - a[1])[0];
    return { name, qty };
  }, [data]);

  const salesSections = useMemo(
    () => (data?.list || []).map((row, index) => {
      const location = resolveSalesLocation(row, tableMetaMap);
      const orderCode = row.order_code || row.code || row.txn_no || row.billno || index + 1;
      const items = (row.summary || []).map((item) => {
        const weightLabel = resolveItemWeightLabel(item);
        const itemName = stripWeightSuffix(item.item_name, weightLabel);
        return {
          ...item,
          item_name: weightLabel ? `${itemName} (${weightLabel})` : itemName,
        };
      });
      const totalQuantity = toNumber(row.total_quantity);
      const totalAmount = toNumber(
        row.total_amount ?? row.totalamount ?? row.bill_amount ?? row.billamount
      );
      return {
        category_name: `Order: ${orderCode} | ${location.typeLabel}: ${location.numberLabel}`,
        item_count: items.length,
        total_quantity: totalQuantity,
        total_amount: totalAmount,
        items: items.length ? items : [{
          item_name: `Order ${orderCode}`,
          total_quantity: totalQuantity,
          total_amount: totalAmount,
        }],
      };
    }),
    [data, tableMetaMap]
  );

  const buildThermalReceipt = (lineWidth) =>
    buildCategorySalesReceiptText(
      {
        title: "Sales Report",
        sectionTotalLabel: "Order Total",
        restaurant: restaurantName,
        addressLines: [
          user?.addressline1 || user?.address || "",
          user?.addressline2 || "",
          user?.addressline3 || "",
        ],
        registrationLines: [
          user?.customfield1 || "",
          user?.customfield2 || "",
          user?.customfield3 || "",
          user?.gstno ? `GSTIN: ${user.gstno}` : "",
        ],
        periodLabel: `From ${displayDate(fromDate)} to ${displayDate(toDate)}`,
        printedAt: new Date(),
        categories: salesSections,
      },
      lineWidth
    );

  const generatedOn = useMemo(
    () =>
      new Date().toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    []
  );

  return (
    <Page>
      <ReportPageHeader
        title="Sales Report"
        subtitle="Track daily summaries, payment mode breakdown, and item sales."
        stats={[
          { label: "Total Amount", value: fmtINR.format(Number(data.total_sale_amount || 0)) },
          { label: "Total Orders", value: data.total_sale_count || 0 },
          { label: "Total Qty", value: data.total_sales_quantity || 0 },
        ]}
      />

      <ReportControlBar>
        <ReportPeriodPicker fromDate={fromDate} toDate={toDate} onChange={({ from, to }) => { setFromDate(from); setToDate(to); }} />
        <TopRight>
          <RefreshBtn onClick={() => fetchReport({ refresh: true })}>
            <FaSyncAlt /> {refreshing ? "Refreshing..." : "Refresh"}
          </RefreshBtn>
          <ExportBtn
            onClick={exportExcel}
            disabled={(data?.list || []).length === 0}
          >
            <FaFileExcel /> Export Excel
          </ExportBtn>
          <ExportBtn
            onClick={exportPDF}
            disabled={(data?.list || []).length === 0}
          >
            <FaDownload /> Export PDF
          </ExportBtn>
          <ExportBtn
            onClick={() => printThermal(
              reportRef.current,
              "Sales Report",
              { buildReceiptText: buildThermalReceipt }
            )}
            disabled={(data?.list || []).length === 0}
          >
            Thermal Print
          </ExportBtn><ExportBtn
            onClick={() => printThermalViaUsb(
              reportRef.current,
              "Sales Report",
              { buildReceiptText: buildThermalReceipt }
            )}
            disabled={(data?.list || []).length === 0}
          >
            Thermal Print via USB
          </ExportBtn>
        </TopRight>
      </ReportControlBar>

      {/* ====== PDF CONTENT STARTS HERE ====== */}
      <Main ref={reportRef}>
        {/* PDF / Print Header */}
        <PdfHeaderCard>
          <PdfBrandRow>
            <PdfBrandLeft>
              <PdfRestaurantName>{restaurantName}</PdfRestaurantName>
              {restaurantAddress && (
                <PdfMetaLine>
                  <FaMapMarkerAlt size={10} />
                  <span>{restaurantAddress}</span>
                </PdfMetaLine>
              )}
              {restaurantPhone && (
                <PdfMetaLine>
                  <FaPhoneAlt size={10} />
                  <span>{restaurantPhone}</span>
                </PdfMetaLine>
              )}
            </PdfBrandLeft>
            <PdfBrandRight>
              <PdfReportTitle>Sales Report</PdfReportTitle>
              <PdfMetaRow>
                <PdfMetaItem>
                  <span>Period</span>
                  <strong>
                    {fromDate} → {toDate}
                  </strong>
                </PdfMetaItem>
                <PdfMetaItem>
                  <span>Generated On</span>
                  <strong>{generatedOn}</strong>
                </PdfMetaItem>
              </PdfMetaRow>
            </PdfBrandRight>
          </PdfBrandRow>
          <PdfDivider />
        </PdfHeaderCard>

        <KpiRow>
          <KpiCard>
            <KpiIcon style={{ color: COLOR.primary }}>
              <FaClipboardList />
            </KpiIcon>
            <KpiLabel>Total Orders</KpiLabel>
            <KpiValue>{data.total_sale_count || 0}</KpiValue>
            <KpiSub>
              {fromDate} → {toDate}
            </KpiSub>
          </KpiCard>
          <KpiCard>
            <KpiIcon style={{ color: COLOR.primary2 }}>
              <FaChartBar />
            </KpiIcon>
            <KpiLabel>Total Quantity</KpiLabel>
            <KpiValue>{data.total_sales_quantity || 0}</KpiValue>
            <KpiSub>All items combined</KpiSub>
          </KpiCard>
          <KpiCard>
            <KpiIcon style={{ color: "#0f9d58" }}>
              <span>{currencySymbol}</span>
            </KpiIcon>
            <KpiLabel>Total Amount</KpiLabel>
            <KpiValue>
              {fmtINR.format(Number(data.total_sale_amount || 0))}
            </KpiValue>
            <KpiSub>Gross for selected period</KpiSub>
          </KpiCard>
        </KpiRow>

        <BadgeRow>
          <Pill>Txn: {data.list.length || 0}</Pill>
          <Pill>
            Period: {fromDate} → {toDate}
          </Pill>
          {topItem ? (
            <Pill className="accent">
              <FaStar /> Top item: {topItem.name} ({topItem.qty})
            </Pill>
          ) : null}
        </BadgeRow>

        {/* Table / Loader */}
        {loading ? (
          <Card>
            <Loader />
            <LoaderLine />
            <LoaderLine />
            <LoaderLine />
          </Card>
        ) : (
          <>
            <Card>
              <Table>
                <thead>
                  <tr>
                    <Th>Particulars</Th>
                    <Th style={{ width: 120, textAlign: "right" }}>Qty</Th>
                    <Th style={{ width: 160, textAlign: "right" }}>Amount</Th>
                  </tr>
                </thead>
                <tbody>
                  {salesSections.slice(start, start + rowsPerPage).map((section, sectionIndex) => (
                    <React.Fragment key={`${section.category_name}-${sectionIndex}`}>
                      <OrderHeadingRow>
                        <Td colSpan={3}>{section.category_name}</Td>
                      </OrderHeadingRow>
                      {section.items.map((item, itemIndex) => (
                        <tr key={`${section.category_name}-${itemIndex}`}>
                          <Td><ItemName>{item.item_name}</ItemName></Td>
                          <NumberCell>{item.total_quantity}</NumberCell>
                          <NumberCell>{fmtINR.format(Number(item.total_amount || 0))}</NumberCell>
                        </tr>
                      ))}
                      <OrderTotalRow>
                        <Td>Order Total</Td>
                        <NumberCell>{section.total_quantity}</NumberCell>
                        <NumberCell>{fmtINR.format(section.total_amount)}</NumberCell>
                      </OrderTotalRow>
                    </React.Fragment>
                  ))}

                  {data.list.length === 0 && (
                    <tr>
                      <Td
                        colSpan={3}
                        style={{
                          textAlign: "center",
                          padding: 24,
                          color: COLOR.muted,
                        }}
                      >
                        No records found for the selected range.
                      </Td>
                    </tr>
                  )}
                </tbody>
                <tfoot>
                  <GrandTotalRow>
                    <Td>Grand Total</Td>
                    <NumberCell>{data.total_sales_quantity || 0}</NumberCell>
                    <NumberCell>{fmtINR.format(Number(data.total_sale_amount || 0))}</NumberCell>
                  </GrandTotalRow>
                </tfoot>
              </Table>

              {/* Pagination (screen view only, still ok in PDF) */}
              <Pager>
                <PageBtn
                  disabled={page === 0}
                  onClick={() => setPage((p) => p - 1)}
                >
                  ‹ Prev
                </PageBtn>
                <PageInfo>
                  Page <strong>{pageCount ? page + 1 : 0}</strong> of{" "}
                  <strong>{pageCount}</strong>
                </PageInfo>
                <PageBtn
                  disabled={page + 1 >= pageCount}
                  onClick={() => setPage((p) => p + 1)}
                >
                  Next ›
                </PageBtn>
              </Pager>
              {error ? <ErrorText>{error}</ErrorText> : null}
            </Card>

            {/* PDF Footer */}
            <PdfFooter>
              <span>Powered by</span>
              <strong>BillSarthi</strong>
            </PdfFooter>
          </>
        )}
      </Main>
    </Page>
  );
};

export default SalesReportPage;

/* ===================== Styles ===================== */

const Page = styled.div`
  min-height: 100vh;
  background: ${COLOR.bg};
  font-family: Inter, system-ui, Segoe UI, Roboto, "Helvetica Neue", Arial;
  color: ${COLOR.text};
`;

const TopBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  background: linear-gradient(90deg, ${COLOR.primary}, ${COLOR.primary2});
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--app-primary);
`;

const TopLeft = styled.div``;
const Title = styled.h1`
  color: #fff;
  margin: 0;
  font-weight: 800;
  font-size: 20px;
`;
const Sub = styled.div`
  color: var(--app-primary-soft);
  font-size: 13px;
  margin-top: 4px;
`;
const PresetRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
`;
const PresetChip = styled.button`
  border: 1px solid ${COLOR.line};
  background: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.12)")};
  color: ${({ $active }) => ($active ? COLOR.primary : "var(--app-primary-soft)")};
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  }
`;
const RefreshBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, var(--app-primary), var(--app-primary-hover));
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(7, 95, 158, 0.2);
  &:hover {
    opacity: 0.92;
  }
`;

const TopRight = styled.div`
  display: flex;
  align-items: end;
  gap: 10px;
  flex-wrap: wrap;
`;

const InputWrap = styled.div`
  display: grid;
  gap: 6px;
`;
const InputLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--app-primary-soft);
  font-size: 12px;
  font-weight: 700;
  svg {
    opacity: 0.95;
  }
`;
const DateInput = styled.input`
  background: #ffffff;
  border: 1px solid ${COLOR.line};
  color: ${COLOR.text};
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 180px;
  outline: none;
  &:focus {
    border-color: ${COLOR.primary};
    box-shadow: 0 0 0 3px rgba(var(--app-primary-rgb), 0.12);
  }
  @media (max-width: 768px) {
    min-width: 0;
    width: 100%;
  }
`;

const ExportBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f57c00;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 800;
  cursor: pointer;
  &:hover {
    background: #ef6c00;
  }
`;

const Main = styled.div`
  padding: 22px;
  @media (max-width: 768px) {
    padding: 12px;
  }
`;

/* ===== PDF Header Styles ===== */

const PdfHeaderCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid ${COLOR.line};
  padding: 16px 18px;
  margin-bottom: 18px;
  box-shadow: 0 6px 14px rgba(var(--app-primary-rgb), 0.06);
`;

const PdfBrandRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 18px;
  flex-wrap: wrap;
`;

const PdfBrandLeft = styled.div`
  min-width: 180px;
  @media (max-width: 768px) {
    min-width: 0;
  }
`;

const PdfRestaurantName = styled.h2`
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: 800;
  color: ${COLOR.primary};
`;

const PdfMetaLine = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${COLOR.muted};
  svg {
    opacity: 0.8;
  }
`;

const PdfBrandRight = styled.div`
  text-align: right;
  min-width: 220px;
  @media (max-width: 768px) {
    min-width: 0;
    text-align: left;
  }
`;

const PdfReportTitle = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: ${COLOR.text};
  margin-bottom: 4px;
`;

const PdfMetaRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

const PdfMetaItem = styled.div`
  font-size: 11px;
  color: ${COLOR.muted};
  span {
    display: block;
    margin-bottom: 2px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  strong {
    color: ${COLOR.text};
  }
`;

const PdfDivider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, ${COLOR.primary}33, transparent);
  margin-top: 10px;
`;

/* ===== PDF Footer Styles ===== */

const PdfFooter = styled.div`
  margin-top: 16px;
  text-align: center;
  font-size: 11px;
  color: ${COLOR.muted};
  padding-top: 8px;
  border-top: 1px dashed ${COLOR.line};
  strong {
    color: ${COLOR.primary};
    margin-left: 4px;
  }
`;

const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 18px;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const KpiCard = styled.div`
  background: ${COLOR.card};
  border: 1px solid ${COLOR.line};
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 10px 30px rgba(var(--app-primary-rgb), 0.08);
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 12px;
  align-items: center;
`;
const KpiIcon = styled.div`
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  font-size: 20px;
`;
const KpiLabel = styled.div`
  color: ${COLOR.muted};
  font-weight: 700;
  font-size: 13px;
`;
const KpiValue = styled.div`
  font-size: 22px;
  font-weight: 900;
`;
const KpiSub = styled.div`
  color: ${COLOR.muted};
  font-size: 12px;
  margin-top: 4px;
`;

const BadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 12px;
`;
const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ecf2ff;
  color: ${COLOR.text};
  border: 1px solid ${COLOR.line};
  border-radius: 999px;
  padding: 8px 12px;
  font-weight: 700;
  &.accent {
    background: #fff7ed;
    border-color: #fed7aa;
  }
`;

const Card = styled.div`
  background: ${COLOR.card};
  border: 1px solid ${COLOR.line};
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(var(--app-primary-rgb), 0.08);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  overflow: hidden;
  border-radius: 12px;
  thead {
    background: ${COLOR.tableHead};
    th {
      color: ${COLOR.text};
      font-weight: 800;
      padding: 12px;
      text-align: left;
      border-bottom: 1px solid ${COLOR.line};
    }
  }
  tbody {
    tr {
      background: #fff;
    }
    tr:nth-child(even) {
      background: #fbfdff;
    }
    tr:hover {
      background: #f4faff;
    }
    .subHead td {
      background: #f4f7fb;
      border-top: 1px solid ${COLOR.line};
      font-size: 13px;
    }
    .subRow td {
      background: ${COLOR.successBg};
    }
    td {
      padding: 12px;
      border-bottom: 1px solid ${COLOR.line};
      vertical-align: middle;
    }
  }
`;

const Th = styled.th``;
const Td = styled.td``;

const ItemName = styled.div`
  color: ${COLOR.text};
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
`;

const NumberCell = styled(Td)`
  text-align: right !important;
  font-variant-numeric: tabular-nums;
`;

const OrderHeadingRow = styled.tr`
  td {
    text-align: center;
    padding: 13px 12px !important;
    background: #eef6ff !important;
    color: #0f4f7d;
    font-weight: 900;
    font-size: 15px;
    border-top: 2px solid #bddcf4;
  }
`;

const OrderTotalRow = styled.tr`
  td {
    background: #f8fafc !important;
    font-weight: 900;
    border-top: 1px dashed #94a3b8;
    border-bottom: 2px solid #cbd5e1;
  }
`;

const GrandTotalRow = styled.tr`
  td {
    padding: 13px 12px;
    background: #e8f3fc;
    color: #0f3f61;
    font-weight: 900;
    border-top: 2px solid var(--app-primary);
  }
`;

const Pager = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 14px;
`;
const PageBtn = styled.button`
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid ${COLOR.primary};
  background: var(--app-primary-soft);
  color: ${COLOR.primary};
  font-weight: 800;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
const PageInfo = styled.div`
  color: ${COLOR.muted};
`;
const ErrorText = styled.div`
  margin-top: 10px;
  color: #c2410c;
  text-align: center;
  font-weight: 700;
`;

/* ------- Loader ------- */
const shimmer = keyframes`
  0% { background-position: -450px 0; }
  100% { background-position: 450px 0; }
`;
const Loader = styled.div`
  height: 18px;
  border-radius: 6px;
  margin: 4px 0 12px 0;
  background: linear-gradient(90deg, #eef3f7 25%, #e3edf7 50%, #eef3f7 75%);
  background-size: 900px 100%;
  animation: ${shimmer} 1.1s linear infinite;
`;
const LoaderLine = styled(Loader)`
  height: 14px;
`;
